import { render, staticRenderFns } from "./SeasonTable.vue?vue&type=template&id=c4ad1294"
import script from "./SeasonTable.vue?vue&type=script&lang=js"
export * from "./SeasonTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports